// メッセージMap
export const MessageMap = {
    "mail_address": "メールアドレス",
    "status_of_residence": "(変更後)在留資格",
};